module.exports = __webpack_public_path__ + "img/angle_300.22348ea3.jpg";